export const formatOptions = [
  {
    name: 'SRT',
    key: 'srt',
    labelKey: 'srt-format',
    descriptionKey: 'srt-format-description'
  },
  {
    name: 'VTT',
    key: 'vtt',
    labelKey: 'vtt-format',
    descriptionKey: 'vtt-format-description'
  },
  {
    name: 'SBV',
    key: 'sbv',
    labelKey: 'sbv-format',
    descriptionKey: 'sbv-format-description'
  },
  {
    name: 'TTML',
    key: 'ttml',
    labelKey: 'ttml-format',
    descriptionKey: 'ttml-format-description'
  },
  {
    name: 'STL',
    key: 'stl',
    labelKey: 'stl-format',
    descriptionKey: 'stl-format-description'
  },
  {
    name: 'HTML',
    key: 'html',
    labelKey: 'html-format',
    descriptionKey: 'html-format-description'
  },
  {
    name: 'Word Document (.docx)',
    key: 'docx',
    labelKey: 'docx-format',
    descriptionKey: 'docx-format-description'
  },
  {
    name: 'Media',
    key: 'media',
    labelKey: 'media-file',
    descriptionKey: 'media-format-description'
  },
  {
    name: 'MP4 (burned-in captions)',
    key: 'mp4-burnt',
    labelKey: 'mp4-burnt-format',
    descriptionKey: 'mp4-burnt-format-description'
  }
];
